module.exports = __webpack_public_path__ + "static/brontosaurus-9aa49ce6af46dc369254a1187f2857fa.jpeg";